import type { SVGProps } from 'react'
const SvgSyFolderDelFill = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M3 8h14.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 9.52 21 10.08 21 11.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 20 18.92 20 17.8 20H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 18.48 3 17.92 3 16.8zm0 0c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C4.602 5 5.068 5 6 5h2.343c.818 0 1.226 0 1.594.152s.657.442 1.235 1.02L13 8z"
		/>
		<path d="m9.854 11.146-.708.708L11.293 14l-2.147 2.146.708.708L12 14.707l2.146 2.147.708-.708L12.707 14l2.147-2.146-.708-.708L12 13.293z" />
	</svg>
)
export default SvgSyFolderDelFill
